// src/js/config/saveToFile.js

import { collectFormData } from './configFormHandler.js';
import { showMessage } from './ui/showMessage.js';

export function saveToFile() {
    const strings = window.SimP_Strings || {};
    const data = collectFormData();

    if (!data || !data.name) {
        showMessage(strings.save_warning_missing_name || 'Ange ett namn för konfigurationen för att spara.', 'warning');
        return;
    }

    try {
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${data.name || "Order configuration"}.json`;
        document.body.appendChild(link); // Krävs för Firefox
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        showMessage(strings.save_file_success || 'Konfigurationen har laddats ner.', 'success');
    } catch (error) {
        console.error('Fel vid sparning till fil:', error);
        showMessage('Kunde inte spara filen.', 'error');
    }
}